/* ONSRA bundle tips – add reward product to cart and refresh drawer/cart via the theme's own cartUpdate pubsub (Grok Bot 21.10.2026) */
(function () {
  if (window.__onsraBundleTips) return;
  window.__onsraBundleTips = true;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  document.addEventListener('change', function (event) {
    var sel = event.target.closest && event.target.closest('select[data-obt-variant]');
    if (!sel) return;
    var item = sel.closest('[data-obt-item]');
    var opt = sel.options[sel.selectedIndex];
    var price = item && item.querySelector('[data-obt-price]');
    if (price && opt && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
    var btn = item && item.querySelector('[data-obt-add]');
    if (btn) btn.setAttribute('data-variant-id', sel.value);
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-obt-add]');
    if (!btn) return;
    event.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;

    var item = btn.closest('[data-obt-item]');
    var box = btn.closest('[data-obt]');
    var sel = item && item.querySelector('select[data-obt-variant]');
    var id = parseInt(sel ? sel.value : btn.getAttribute('data-variant-id'), 10);
    var err = item && item.querySelector('[data-obt-err]');
    if (!id) return;

    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    if (box && box.getAttribute('data-obt-adding')) btn.textContent = box.getAttribute('data-obt-adding');
    if (err) err.hidden = true;

    // same mechanism as the theme's product form: collect the sections that want re-rendering
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || r.data.status) throw new Error(r.data.description || r.data.message || 'error');
        return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            cart.sections = r.data.sections;
            var canPublish = window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS && r.data.sections && sections.length;
            if (canPublish) {
              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'onsra-bundle-tips', cart: cart, productVariantId: id });
            } else if (document.body.classList.contains('template-cart')) {
              window.location.reload();
              return;
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
            }
            document.dispatchEvent(new CustomEvent('onsra:bundle-tip-added', { detail: { variantId: id, cart: cart } }));
          });
      })
      .catch(function (e) {
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
        if (err) {
          err.textContent = (box && box.getAttribute('data-obt-error')) + (e && e.message && e.message !== 'error' ? ' ' + e.message : '');
          err.hidden = false;
        }
      });
  });
})();
